module.exports = __webpack_public_path__ + "img/album21_26.b63a7a3a.jpg";